import React from 'react';
import styled from 'styled-components/macro';
import LogoRegis from '../../assets/img/logoRegisNegro.png';
import { responsive } from '../../resources/constantes.json';
/**
 *  Lista de checkbox que permite elegir entre varias opciones. Se utiliza en la pantalla
 * de estadísitcas para elegir entre distintos tipos de estadísticas.
 */

const FooterLayout = props => {

  return (
    <FooterContainer estadisticas={props.estadisticas} >
      <SLogoRegistraduria>
        <img src={LogoRegis} alt={"Logo registraduria"} />
      </SLogoRegistraduria>
      <div>
        <TextFooter>
        De conformidad con el parágrafo 2 del artículo 2 de la Resolución No. 1706 de 2019 del CNE, los boletines expedidos por la Registraduría Nacional del Estado Civil, 
				durante el denominado preconteo, no son de carácter vinculante y tienen mero carácter informativo, por lo que no pueden considerarse como documentos electorales que definan una elección. 
				<br/>Los porcentajes se calculan y muestran con reducción a 2 dígitos a la derecha del separador decimal (término matemático: truncamiento a 2 decimales).
				<br/>Es importante tener en cuenta que, el concepto de agrupación política utilizado incluye a los partidos y movimientos políticos con personería jurídica, grupos significativos de ciudadanos y coaliciones entre estos.
      </TextFooter>
      </div>
    </FooterContainer>
  );
};

export default FooterLayout;

const SLogoRegistraduria = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  & img {
    height: 80px;
    vertical-align: middle;
    margin-right: 20px;
  }
  @media (max-width: 1024px) {
    padding: 0 15px;
  }
`;
const FooterContainer  = styled(({ estadisticas, ...rest }) => (
  <footer {...rest} />
))`
 width: 100%;
 //max-width:1366px;
 margin: 0 auto;
 display: flex;
 flex-direction: row;
 align-items: center;
//  background: ${({ estadisticas }) => estadisticas ? "white" : "transparent"};
 @media (max-width: ${responsive.tablet}px) {
  padding-top: 10px;
  width: 100%;
  flex-direction: column;
}
`;

const TextFooter  = styled.p`
 font-size: 10px;
 line-height: 15px;
`;